module.exports = __webpack_public_path__ + "assets/img/forest.29036a14.png";